import {useReducer} from 'react';

const SET = 'SET';
const UNDO = 'UNDO';
const REDO = 'REDO';
const RESET = 'RESET';

const reducer = (state, action) => {
  const {past, present, future} = state;

  switch (action.type) {
    case SET: {
      return {
        past: [...past, present],
        present: action.newPresent,
        future: [],
      };
    }
    case UNDO: {
      const previous = past[past.length - 1];
      const newPast = past.slice(0, past.length - 1);

      return {
        past: newPast,
        present: previous,
        future: [present, ...future],
      };
    }
    case REDO: {
      const next = future[0];
      const newFuture = future.slice(1);

      return {
        past: [...past, present],
        present: next,
        future: newFuture,
      };
    }
    case RESET: {
      return {
        past: [],
        present: action.newPresent,
        future: [],
      };
    }
    default:
      return state;
  }
};

export default function useUndoableState(initialState) {
  const [state, dispatch] = useReducer(reducer, {
    past: [],
    present: initialState,
    future: [],
  });

  const canUndo = state.past.length > 0;

  const set = newPresent => dispatch({type: SET, newPresent});

  const undo = () => dispatch({type: UNDO});

  const redo = () => dispatch({type: REDO});

  const reset = newPresent => dispatch({type: RESET, newPresent});

  const undoableBag = {
    undo,
    redo,
    reset,
    canUndo,
  };

  return [state.present, set, undoableBag];
}
